import React, {
  type FC,
  type PropsWithChildren,
  type ButtonHTMLAttributes,
  type AnchorHTMLAttributes
} from 'react'
import clsx from 'clsx'
import styles from './Button.scss'

type CommonProps = {
  onClick?: () => void
  isActive?: boolean
  className?: string
  size?: 'middle' | 'big'
  color?: 'primary' | 'rewarded'
}

export type ButtonProps = {
  type?: 'button'
  otherProps?: ButtonHTMLAttributes<HTMLButtonElement>
} & PropsWithChildren & CommonProps

export type ButtonLinkProps = {
  type: 'link'
  otherProps?: AnchorHTMLAttributes<HTMLAnchorElement>
} & PropsWithChildren & CommonProps

export const Button: FC<ButtonProps | ButtonLinkProps> = props => {
  const {
    onClick,
    children,
    isActive,
    className,
    type,
    otherProps,
    size = 'middle',
    color = 'primary',
  } = props

  return (
    <>
      {(type === 'button' || !type) &&
        <button
          className={clsx(
            styles.button,
            styles[`button__${size}`],
            styles[`button__${size}__${color}`],
            isActive && styles[`button__${size}__${color}__active`],
            className,
          )}
          onClick={onClick}
          {...otherProps}
        >
          {children}
        </button>
      }
      {type === 'link' &&
        <a
          className={clsx(
            styles.button,
            styles[`button__${size}`],
            styles[`button__${size}__${color}`],
            isActive && styles[`button__${size}__${color}__active`],
            className,
          )}
          onClick={onClick}
          {...otherProps}
        >
          {children}
        </a>
      }
    </>

  )
}
